import React from 'react';

interface CorrectFeedbackProps {
    explanation?: string;
    xpAwarded?: number;
    livesRemaining?: number;
    streakDays?: number;
}

export default function CorrectFeedback({
    explanation,
    xpAwarded = 0,
    livesRemaining = 0,
    streakDays = 0,
}: CorrectFeedbackProps) {
    return (
        <div className="overflow-hidden border border-[#2d3554] bg-[#111111] shadow-[0_0_30px_rgba(140,172,255,0.12)]">
            <div className="border-b border-[#26304f] bg-[#171d2f] px-6 py-4">
                <div className="flex items-center justify-between gap-4">
                    <div className="flex items-center gap-3">
                        <span className="flex h-11 w-11 items-center justify-center border border-[#00cffc] bg-[#001b20] text-xl text-[#00cffc]">
                            ✓
                        </span>
                        <div>
                            <p className="font-['IBM_Plex_Mono'] text-[11px] uppercase tracking-[0.32em] text-[#8cacff]">
                                SYSTEM_VALIDATED
                            </p>
                            <h3 className="mt-2 font-['Space_Grotesk'] text-3xl font-black uppercase italic text-white">
                                Critical Hit Confirmed
                            </h3>
                        </div>
                    </div>
                    <span className="border border-[#00cffc]/30 bg-[#00cffc]/10 px-3 py-2 font-['IBM_Plex_Mono'] text-[11px] uppercase tracking-[0.28em] text-[#00cffc]">
                        ARENA_CLEAR
                    </span>
                </div>
            </div>

            <div className="px-6 py-6">
                <p className="text-base leading-relaxed text-[#dedede]">
                    {explanation || 'Target resolved cleanly. Push forward before the arena sync drops.'}
                </p>

                <div className="mt-6 grid gap-4 sm:grid-cols-3">
                    <div className="border border-[#242424] bg-[#151515] px-4 py-4">
                        <p className="font-['IBM_Plex_Mono'] text-[10px] uppercase tracking-[0.24em] text-[#767575]">
                            XP Gained
                        </p>
                        <p className="mt-2 font-['Space_Grotesk'] text-2xl font-black uppercase text-[#00cffc]">
                            +{xpAwarded}
                        </p>
                    </div>
                    <div className="border border-[#242424] bg-[#151515] px-4 py-4">
                        <p className="font-['IBM_Plex_Mono'] text-[10px] uppercase tracking-[0.24em] text-[#767575]">
                            Streak Sync
                        </p>
                        <p className="mt-2 font-['Space_Grotesk'] text-2xl font-black uppercase text-[#d674ff]">
                            {streakDays}D
                        </p>
                    </div>
                    <div className="border border-[#242424] bg-[#151515] px-4 py-4">
                        <p className="font-['IBM_Plex_Mono'] text-[10px] uppercase tracking-[0.24em] text-[#767575]">
                            Lives Left
                        </p>
                        <p className="mt-2 font-['Space_Grotesk'] text-2xl font-black uppercase text-[#8cacff]">
                            {String(livesRemaining).padStart(2, '0')}
                        </p>
                    </div>
                </div>

                <div className="mt-6 border border-[#00cffc]/25 bg-[#00cffc]/8 px-5 py-4">
                    <p className="font-['IBM_Plex_Mono'] text-[11px] uppercase tracking-[0.3em] text-[#00cffc]">
                        INITIATE NEXT_TASK
                    </p>
                    <p className="mt-2 text-sm leading-relaxed text-[#cceff6]">
                        Hold position. The next node will load automatically.
                    </p>
                </div>
            </div>
        </div>
    );
}
